import {
    Button,
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from "@/shared/components";
import { RowData, Table } from "@tanstack/react-table";
import type { DataTableFeatures } from "./data-table-features";

type DataTableColumnVisibilityProps<TData extends RowData> = {
    table: Table<DataTableFeatures, TData>;
};

export function DataTableColumnVisibility<TData extends RowData>({ table }: DataTableColumnVisibilityProps<TData>) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild data-testid="column-visibility">
                <Button variant="tertiary" className="ml-auto shrink-0">
                    Kolommen
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" data-testid="column-visibility">
                {table
                    .getAllColumns()
                    .filter((column) => column.getCanHide())
                    .map((column) => {
                        return (
                            <DropdownMenuCheckboxItem
                                key={column.id}
                                className="capitalize"
                                checked={column.getIsVisible()}
                                onCheckedChange={(value) => column.toggleVisibility(!!value)}
                            >
                                {column.id}
                            </DropdownMenuCheckboxItem>
                        );
                    })}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
